import queryString from 'query-string';

import { RouteQueryParamStartDate } from './constants';
import { parseDateStr } from './dateTimeHelpers';

/**
 * Checks the start of the url to see if the page is one without the map
 * @param pathname the current path that is active
 */
export function computeIsMapHidden(pathname: string) {
  return /^\/(?:settings|admin-settings|outlook-reports|risk-matrix|overview|covid-ds|connectivity)/i.test(
    pathname
  );
}

/**
 * Extract the startDate URL query param (location.search), however if as a date it violates
 * timeframe range, return DefaultTimeframeStartDateType. If the URL param is one of
 * LowerBoundDateRangeLiteral, return that "moment ago" (PT-1908).
 * @param location, either DOM window.location or ReachRouter HistoryLocation. For the needs of this function they overlap.
 * @returns a tuple: [startDate, isUrlParamValid], date string in YYYY-MM-DD format, if invalid, return DefaultTimeframeStartDateType.
 * Second member is validity flag of the URL param.
 */
export function extractTimeframeStartDate(searchParams: string): [string, boolean] {
  const queryObj = queryString.parse(searchParams);
  const startDateParam = queryObj[RouteQueryParamStartDate] as string;
  return parseDateStr(startDateParam);
}

/**
 * @param {Location} location - browser window location
 * @param {string} path - app path
 * @returns whether or not the specified url string starts with the specified path string
 * (used for determining if a url is associated with a router path)
 */
export function locationWithinPath(activePath: string, path: string): boolean {
  if (!activePath) return false;
  return activePath.startsWith(path);
}
